import style from './index.module.scss';
import {Button, message, Modal} from 'antd';
import React from 'react';
import {errorMessage, isTrue} from 'Utils/common';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import {
    changePlanStatus,
    deletePlan,
    PlanListItem,
    Status,
} from '../../../service';
import AddPlanModal from '../AddPlanModal';

interface OperationsProps {
    record: PlanListItem; //当前课程列表
    updateData: () => void; //更新函数
}

export default function Operations({record, updateData}: OperationsProps) {
    const editModal = useModalHandler({
        component: AddPlanModal,
    });

    const handleChange = async (status: string) => {
        try {
            await changePlanStatus(record.id, status);
            updateData();
            message.success(status === Status.Open ? '启用成功' : '停用成功');
        } catch (e) {
            message.error(errorMessage(e));
        }
    };

    //删除任务
    function handleDelete(id: string) {
        Modal.confirm({
            title: `删除调度计划？`,
            content:
                '删除调度计划后自动解除计划与任务的关联关系，且删除后不可恢复，确定删除？',
            onOk: async () => {
                try {
                    await deletePlan(id);
                    message.success('调度计划删除成功');
                    updateData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            },
        });
    }

    return (
        <div className={style.tools}>
            <div className={style.container}>
                {isTrue(record.status) && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={() => handleChange('0')}>
                        停用
                    </Button>
                )}
                {!isTrue(record.status) && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={() => handleChange('1')}>
                        启用
                    </Button>
                )}
                <Button
                    type="link"
                    className={style.btn}
                    onClick={() =>
                        editModal.open({
                            flag: 'edit',
                            initValue: record,
                            refreshData: () => {
                                updateData();
                                editModal.close();
                            },
                        })
                    }>
                    编辑
                </Button>
                <Button
                    type="link"
                    className={style.btn}
                    onClick={() => handleDelete(record.id)}>
                    删除
                </Button>
            </div>

            {editModal.render()}
        </div>
    );
}
